<template>
  <svg
    class="text-brand-soft h-5 w-5"
    aria-hidden="true"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.5714 14.5711V16.2854C20.5714 16.5176 20.4866 16.7185 20.317 16.8881C20.1473
             17.0578 19.9464 17.1426 19.7143 17.1426H0.857143C0.625 17.1426 0.424107 17.0578
             0.254464 16.8881C0.0848214 16.7185 0 16.5176 0 16.2854V14.5711C0 14.339 0.0848214
             14.1381 0.254464 13.9685C0.424107 13.7988 0.625 13.714 0.857143 13.714H19.7143C19.9464
             13.714 20.1473 13.7988 20.317 13.9685C20.4866 14.1381 20.5714 14.339 20.5714
             14.5711ZM20.5714 7.71401V9.42829C20.5714 9.66044 20.4866 9.86133 20.317
             10.031C20.1473 10.2006 19.9464 10.2854 19.7143 10.2854H0.857143C0.625 10.2854
             0.424107 10.2006 0.254464 10.031C0.0848214 9.86133 0 9.66044 0 9.42829V7.71401C0
             7.48186 0.0848214 7.28097 0.254464 7.11133C0.424107 6.94169 0.625 6.85686 0.857143
             6.85686H19.7143C19.9464 6.85686 20.1473 6.94169 20.317 7.11133C20.4866 7.28097 20.5714
             7.48186 20.5714 7.71401ZM20.5714 0.856865V2.57115C20.5714 2.80329 20.4866 3.00419
             20.317 3.17383C20.1473 3.34347 19.9464 3.42829 19.7143 3.42829H0.857143C0.625
             3.42829 0.424107 3.34347 0.254464 3.17383C0.0848214 3.00419 0 2.80329 0
             2.57115V0.856865C0 0.624722 0.0848214 0.42383 0.254464 0.254187C0.424107 0.0845432
             0.625 -0.000278473 0.857143 -0.000278473H19.7143C19.9464 -0.000278473 20.1473
             0.0845432 20.317 0.254187C20.4866 0.42383 20.5714 0.624722 20.5714 0.856865Z"
      fill="currentColor" />
  </svg>
</template>
